/* @jsxImportSource react */

import type { FC, ReactNode } from 'react';

export type SlotsContainerProps = {
  children?: ReactNode;
};

export const SlotsContainer: FC<SlotsContainerProps> = ({ children }) => (
  <div className="slots-container flex w-full items-center justify-end gap-1.5 px-1 py-0.5 max-lg:@container lg:gap-3 xl:pr-[2px]">
    {children}
  </div>
);
